export default __webpack_public_path__ + "static/media/Luciamini_Guide.ae1c14a2.pdf";